<template>
  <div id="app">
    <intro />
    <figtree />
    <eccll />
    <crews />
  </div>
</template>

<script>
import Intro from './components/Intro.vue'
import Figtree from './components/Figtree.vue'
import Eccll from './components/Eccll.vue'
import Crews from './components/Crews.vue'

export default {
  name: 'KARULAB',
  components: {
    Intro,
    Figtree,
    Eccll,
    Crews,
  }
}
</script>

<style>
@import url(https://cdn.rawgit.com/kattergil/NotoSerifKR-Web/76eb9ebf/stylesheet/NotoSerif-Web.css);
@import url(https://fonts.googleapis.com/earlyaccess/notosanskr.css);
.serif {
  font-family: 'Noto Serif KR'
}
.sans {
  font-family: 'Noto Sans KR'
}
.kl-title {
  font-size: 53px;
}
.kl-sm-title {
  font-size: 27px;
}
.kl-description {
  font-size: 23px;
}
a {
  text-decoration: none;
}
#app {
  font-family: 'Noto Serif KR', 'Noto Sans KR', 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  max-width: 1080px;
  text-align: center;
  color: #2c3e50;
  margin: auto;
}
body {
  margin: 0px;
}

@media screen and (max-width: 640px) {
  .kl-title {
    font-size: 38px;
  }
  .kl-sm-title {
    font-size: 17px;
  }
  .kl-description {
    font-size: 13px;
  }
}
</style>
